import { InkindPageAPIModel } from '../models/gik/InkindPage';

export const gofundmeRegex = /^(http(s)?:\/\/)?(www\.)?gofundme\.com\/f\/(.)/;

export function extractCampaignSlug(url: string) {
  return url?.split('f/')?.[1]?.split('?')[0] || '';
}

export function getGoFundMeURL(inkindPage: InkindPageAPIModel) {
  const url = inkindPage?.financialContributions?.goFundMeUrl;

  if (url) {
    if (!url.includes('f/')) {
      return 'https://gofundme.com/f/' + url;
    } else {
      return url;
    }
  } else {
    return '';
  }
}
